import { isString } from "../utils/is.js";
//#region src/api/utils.ts
function shouldIgnoreEvent(patterns, msg) {
	return patterns.some((pattern) => {
		return isString(pattern) ? msg.includes(pattern) : !!msg.match(pattern);
	});
}
//#endregion
export { shouldIgnoreEvent };

//# sourceMappingURL=utils.js.map